import React, { useEffect, useState } from 'react';
import './Chat.css';
import Dropzone from 'react-dropzone';
import { Icon } from 'antd';
import InfinitScroll from 'react-infinite-scroll-component';
import styles from './ChatConversation.module.css';
import MessagesPanel from './MessagesPanel';
import MessageInputField from './MessageInputField';
import { isEmpty } from '../helper';
import { sendAnalyticsEvent } from '../analytics';

const Conversation = (props) => {
  const { channelProxy } = props;
  const itemsPerPage = 20;
  const [newMessage, setNewMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [loadingState, setLoadingState] = useState('initializing');
  const [hasSentMessage, setHasSentMessage] = useState(false);

  useEffect(() => {
    if (!channelProxy) {
      return () => {};
    }

    setMessages([]);
    setNewMessage('');

    // Prevent race condition: https://medium.com/hackernoon/avoiding-race-conditions-when-fetching-data-with-react-hooks-220d6fd0f663
    let canceled = false;

    // Load first page
    channelProxy
      .getMessages(itemsPerPage)
      .then((messagePaginator) => {
        if (canceled) {
          return;
        }

        setMessages(messagePaginator.items);
        setLoadingState('ready');
      })
      .catch((err) => {
        console.error("Couldn't fetch messages", err);
        setLoadingState('failed');
      });

    // Add listener
    const messageAdded = (message, targetChannel) => {
      if (targetChannel === channelProxy) {
        setMessages((prev) => [...prev, message]);
      }
    };

    const listener = (m) => messageAdded(m, channelProxy);
    channelProxy.on('messageAdded', listener);

    return () => {
      canceled = true;
      channelProxy.removeListener('messageAdded', listener);
    };
  }, [channelProxy]);

  const infiniteScrollMessageBar = (targetChannel) => {
    setHasSentMessage(false);

    targetChannel
      .getMessages(itemsPerPage + 1, messages[0]?.state?.index)
      .then((messagePaginator) => {
        if (targetChannel !== channelProxy) {
          return;
        }

        const updatedMessages = messages.filter((item, index) => index !== 0);
        setMessages([...messagePaginator.items, ...updatedMessages]);
        setLoadingState('ready');
      })
      .catch((err) => {
        console.error("Couldn't fetch messages", err);
        setLoadingState('failed');
      });
  };

  const onMessageChange = (event) => {
    channelProxy.typing();
    setNewMessage(event.target.value);
  };

  const sendMessage = (event) => {
    event.preventDefault();
    if (newMessage !== '') {
      channelProxy.sendMessage(newMessage, {
        from_employee: true,
        source: 'admin_portal',
      });
      setHasSentMessage(true);
      setNewMessage('');
      sendAnalyticsEvent('customMessageSent', { type: 'text' });
    }
  };

  const onDrop = (acceptedFiles) => {
    channelProxy.sendMessage(
      {
        contentType: acceptedFiles[0].type,
        media: acceptedFiles[0],
      },
      { from_employee: true, source: 'admin_portal' },
    );
    sendAnalyticsEvent('customMessageSent', {
      type: acceptedFiles[0].type,
    });
  };

  const { myIdentity, userTyping, setSnackbar } = props;

  return (
    <Dropzone onDrop={onDrop} accept="image/*">
      {({ getRootProps, getInputProps, isDragActive }) => (
        <div
          {...getRootProps()}
          onClick={() => {}}
          id="OpenChannel"
          style={{ position: 'relative', top: 0, overflow: 'hidden' }}
        >
          {isDragActive && (
            <div className={styles.drop}>
              <Icon
                type="cloud-upload"
                style={{ fontSize: '5em', color: '#fefefe' }}
              />
              <h3 style={{ color: '#fefefe' }}>Release to Upload</h3>
            </div>
          )}
          <div
            className={styles.messages}
            id="scrollableDiv"
            style={{
              filter: `blur(${isDragActive ? 4 : 0}px)`,
            }}
          >
            <input id="files" {...getInputProps()} />
            <InfinitScroll
              dataLength={messages.length}
              next={() => {
                infiniteScrollMessageBar(channelProxy);
              }}
              style={{ display: 'flex', flexDirection: 'column-reverse' }}
              inverse
              hasMore
              initialScrollY={0}
              scrollableTarget="scrollableDiv"
            >
              <MessagesPanel
                currentConversation={channelProxy}
                identity={myIdentity}
                messages={messages}
                hasSentMessage={hasSentMessage}
              />
            </InfinitScroll>
          </div>
          {!isEmpty(userTyping) &&
            userTyping?.conversation?.sid === channelProxy?.sid &&
            userTyping.state.attributes.name && (
              <div
                style={{
                  backgroundColor: 'white',
                  margin: '5px auto',
                  width: '90%',
                  maxWidth: '600px',
                }}
              >
                {userTyping.state.attributes.name} is typing...
              </div>
            )}
          <MessageInputField
            sendMessage={sendMessage}
            loadingState={loadingState}
            onMessageChange={onMessageChange}
            newMessage={newMessage}
            setSnackbar={setSnackbar}
            conversation={channelProxy}
          />
        </div>
      )}
    </Dropzone>
  );
};

export default Conversation;
